import { render, staticRenderFns } from "./GlobalAlerts.vue?vue&type=template&id=3ea3115b"
import script from "./GlobalAlerts.vue?vue&type=script&lang=js"
export * from "./GlobalAlerts.vue?vue&type=script&lang=js"
import style0 from "./GlobalAlerts.vue?vue&type=style&index=0&id=3ea3115b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports